module.exports = __webpack_public_path__ + "static/media/bursary.067ca4b7.svg";